import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_EOD,
  CREATE_EODS,
  DELETE_EOD,
  UPDATE_EOD,
  UPDATE_EODS,
  GET_LAST_EOD_RAN_TODAY,
  GET_EOD_HISTORY,
  SET_EOD_HISTORY_VIEW
} from '../actions';

const initialEODHistoryViewState = {
  loading: <boolean>false
};

export function lastEODRanTodayReducer(state = false, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return false;
    case GET_LAST_EOD_RAN_TODAY:
      return action.payload.lastEODRanToday;
    default:
      return state;
  }
}

export function eodHistoryReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_EOD:
      const match = state.find(eod => action.payload.eod && eod.id === action.payload.eod.id);
      return !match
        ? [ ...state, action.payload.eod ].sort(sortEODs)
        : state;
    case CREATE_EODS:
      return [ ...state, action.payload.eods ].sort(sortEODs);
    case DELETE_EOD:
      return state.filter(eod => eod.id !== action.payload.id);
    case UPDATE_EOD:
      return state.map(eod => {
        return eod.id === action.payload.eod.id
          ? action.payload.eod
          : eod;
      });
    case UPDATE_EODS:
      return state.map(stateEOD => {
        const match = action.payload.eods.find(eod => eod.id === stateEOD.id);
        return !match ? stateEOD : match;
      });
    case GET_EOD_HISTORY:
      return [ ...action.payload.eodHistory ].sort(sortEODs);
    default:
      return state;
  }
}

export function eodHistoryViewReducer(state = initialEODHistoryViewState, action: Action) {
  switch (action.type) {
    case SET_EOD_HISTORY_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

const sortEODs = (eod1, eod2) => {
  return +eod2.runDate - +eod1.runDate;
};

export const eodReducers = combineReducers({
  eodHistory      : eodHistoryReducer,
  eodHistoryView  : eodHistoryViewReducer,
  lastEODRanToday : lastEODRanTodayReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/eod.ts